import React, { useState } from 'react';
import { Button, InputGroup, FormControl, Row, Col } from 'react-bootstrap';
import ImageIconLoader from '../ImageIconLoader';
import './ButtonRow.css'
interface ButtonsHome {
  name:string,
  toggleView: () => void;
  isGridView: boolean;
  handleSearch: (event: any) => void;
  handleSearchTag: (event: any) => void;
  handleFav?:(val:string | undefined) => void;
  searchTerm: string;
  data: any;
  tagSelected: string | undefined;
  isFilteredFav: boolean;
}
const ButtonsHome: React.FC<ButtonsHome> = ({name, toggleView, isGridView, handleSearch, searchTerm, data, handleSearchTag, tagSelected, handleFav, isFilteredFav }) => {
  return (
    <div className="">
      <Row>
        <Col md={6} className='d-flex align-items-center  justify-content-start'>
          {/* {data && data.map((item: any) => (
            <Button variant="" className={`me-2 btn-custom minw-btn ${item.tag_description == tagSelected ? 'active' : ''} `} onClick={() => handleSearchTag(item.tag_description)}>{item.tag_description}</Button>
          ))}

          <Button variant="" className={`me-2 btn-custom minw-btn ${isFilteredFav ? 'active' : ''}`} onClick={handleFav}>Favorites</Button> */}
          <h4>{name}</h4>
            
        </Col>
        <Col md={6} className='d-flex align-items-center  justify-content-between'>
          <InputGroup className="search-input">
            <FormControl
              placeholder="Search"
              value={searchTerm}
              onChange={handleSearch}
            />
            <InputGroup.Text className="search-icon">
              <ImageIconLoader name={"iconsearch"} alt="" width={30} />
            </InputGroup.Text>
          </InputGroup>
          <Button className={`mx-2 btn-custom-gridlist d-flex ${!isGridView ? 'activelistgrid' : ''}`}
            variant={isGridView ? 'primary' : 'secondary'}
            onClick={toggleView}>
            <ImageIconLoader name={"iconlist"} alt="" width={30} />
          </Button>
          <Button
            className={`me-2 btn-custom-gridlist  d-flex ${isGridView ? 'activelistgrid' : ''}`}
            onClick={toggleView}
          >
            <ImageIconLoader name={"icongrid"} alt="" width={25} />
          </Button>
        </Col>
      </Row>

    </div>
  );
};

export default ButtonsHome;
